// Aviso de "nueva versión disponible" para la PWA.
// Cuando el Service Worker detecta una versión nueva (queda en estado "waiting"),
// se muestra un banner. Al pulsar "Actualizar" se activa el SW nuevo (SKIP_WAITING)
// y la página se recarga una sola vez cuando el nuevo SW toma el control.
// Es DOM puro y autocontenido: no depende de la estructura de React ni de CSS externo.

let refreshing = false;

/**
 * Muestra el banner de actualización.
 * @param {ServiceWorkerRegistration} registration
 */
export function showUpdatePrompt(registration) {
  const waiting = registration && registration.waiting;
  if (!waiting) return;                                  // nada que activar
  if (document.getElementById('sw-update-banner')) return; // evitar duplicados

  const banner = document.createElement('div');
  banner.id = 'sw-update-banner';
  banner.setAttribute('role', 'status');
  banner.style.cssText = [
    'position:fixed', 'left:50%', 'bottom:20px', 'transform:translateX(-50%)',
    'z-index:2147483647', 'max-width:92%', 'box-sizing:border-box',
    'display:flex', 'align-items:center', 'gap:14px',
    'padding:12px 16px', 'border-radius:12px',
    'background:#0B5394', 'color:#ffffff',
    'font-family:system-ui,-apple-system,"Segoe UI",Roboto,sans-serif', 'font-size:15px',
    'box-shadow:0 8px 24px rgba(0,0,0,.25)',
  ].join(';');

  const text = document.createElement('span');
  text.textContent = 'Hay una nueva versión disponible';
  text.style.cssText = 'flex:1;line-height:1.3';

  const btn = document.createElement('button');
  btn.type = 'button';
  btn.textContent = 'Actualizar';
  btn.style.cssText = [
    'flex:none', 'cursor:pointer', 'border:none', 'border-radius:8px',
    'padding:9px 16px', 'font-size:15px', 'font-weight:600',
    'background:#13A89E', 'color:#ffffff',
  ].join(';');

  const close = document.createElement('button');
  close.type = 'button';
  close.setAttribute('aria-label', 'Descartar');
  close.textContent = '×';
  close.style.cssText = [
    'flex:none', 'cursor:pointer', 'border:none', 'background:transparent',
    'color:#cfe0ec', 'font-size:22px', 'line-height:1', 'padding:0 2px',
  ].join(';');
  close.addEventListener('click', () => banner.remove());

  btn.addEventListener('click', () => {
    btn.disabled = true;
    btn.textContent = 'Actualizando…';
    // Cuando el SW nuevo tome control, recargar una sola vez.
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
    waiting.postMessage({ type: 'SKIP_WAITING' });
  });

  banner.appendChild(text);
  banner.appendChild(btn);
  banner.appendChild(close);
  document.body.appendChild(banner);
}
